export const MATCHES_LOADED = "MATCHES_LOADED";
export const MATCH_1_LEVEL_FIELD_UPDATED = "MATCH_1_LEVEL_FIELD_UPDATED";
export const MATCH_USER_FIELD_UPDATED = "MATCH_USER_FIELD_UPDATED";
export const IDEAL_CANDIDATE_FIELD_UPDATED = "IDEAL_CANDIDATE_FIELD_UPDATED";
export const MAPPED_HITS_TAB_MATCHES_FOR_DOWNLOAD_UPDATED =
  "MAPPED_HITS_TAB_MATCHES_FOR_DOWNLOAD_UPDATED";
export const IDEAL_CANDIDATES_LOADED = "IDEAL_CANDIDATES_LOADED";
export const LOADING_IDEAL_CANDIDATES = "LOADING_IDEAL_CANDIDATES";
export const IS_RE_RANKING_MATCHES_CHANGED = "IS_RE_RANKING_MATCHES_CHANGED";
